import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { GetAppConnectedSessions, HandleServerMessageWebSocketCreated, HandleServerMessageWebsocketDeleted, SetCoreData } from './core.actions';
import { AppConnectedSessionModel, CoreStateModel } from './core.model';
import { WebSocketService } from '../websocket/websocket.service';
import { tap } from 'rxjs';
import { catchError } from 'rxjs';
import { AppSessionsService } from '../app-sessions/app-sessions.service';



@State<CoreStateModel>({
  name: 'CoreState',
  defaults: {
    appConnectedSessions: []
  }
})
@Injectable()
export class CoreState {
  private webSocketService = inject(WebSocketService);
  private appSessionsService = inject(AppSessionsService);
  @Selector()
  static getCoreData(state: CoreStateModel): CoreStateModel {
    return CoreState.getInstanceState(state);
  }

  private static setInstanceState(state: CoreStateModel): CoreStateModel {
    return { ...state };
  }

  private static getInstanceState(state: CoreStateModel): CoreStateModel {
    return { ...state };
  }

  @Action(SetCoreData)
  setCoreData(
    { setState }: StateContext<CoreStateModel>,
    { payload }: SetCoreData
  ) {
    setState(CoreState.setInstanceState(payload));
  }

  @Action(GetAppConnectedSessions)
  getAppConnectedSessions({ patchState }: StateContext<CoreStateModel>) {
    return this.appSessionsService.getAppConnectedSessions().pipe(
      catchError((error) => {
        console.error('Error getting app connected sessions', error);
        throw error;
      }),
      tap((sessions: AppConnectedSessionModel[]) => {
        // // console.log('sessions :>> ', sessions);
        patchState({ appConnectedSessions: sessions });
      })
    );
  }

  @Action(HandleServerMessageWebSocketCreated)
  handleServerMessageCreated({ patchState, getState }: StateContext<CoreStateModel>, { payload }: any) {
    // // console.log('payload created:>> ', payload);
    const state = getState();
    const currentSessions = state.appConnectedSessions;
    // // console.log('currentSessions :>> ', currentSessions);
    patchState({
      appConnectedSessions: [...currentSessions, payload]
    });
  }

  @Action(HandleServerMessageWebsocketDeleted)
  handleServerMessageWebsocketDeleted({ patchState, getState }: StateContext<CoreStateModel>, { payload }: any) {
    // // console.log('payload deleted:>> ', payload);
    const state = getState();
    const currentSessions = state.appConnectedSessions;
    // // console.log('currentSessions :>> ', currentSessions);
    patchState({
      appConnectedSessions: currentSessions.filter(session => session.socketId !== payload)
    });
  }
}